var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealeState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "19.999 25 160.002 150",
    viewBox: "19.999 25 160.002 150",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.555 61.102a3.812 3.812 0 0 1-3.81-3.814V38.983a3.811 3.811 0 1 1 7.62 0v18.305a3.811 3.811 0 0 1-3.81 3.814zM155.873 77.373a3.812 3.812 0 0 1-3.81-3.814V38.983a3.811 3.811 0 1 1 7.62 0v34.576a3.812 3.812 0 0 1-3.81 3.814z",
    fill: "#fff",
    "data-color": 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.873 42.797h-20.317a3.812 3.812 0 0 1-3.81-3.814 3.812 3.812 0 0 1 3.81-3.814h20.317a3.812 3.812 0 0 1 3.81 3.814 3.812 3.812 0 0 1-3.81 3.814zM23.81 175a3.812 3.812 0 0 1-3.81-3.814V89.831a3.811 3.811 0 1 1 7.62 0v81.356A3.812 3.812 0 0 1 23.81 175zM176.19 175a3.812 3.812 0 0 1-3.81-3.814V89.831a3.811 3.811 0 1 1 7.62 0v81.356a3.812 3.812 0 0 1-3.81 3.813z",
    fill: "#fff",
    "data-color": 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.19 175H23.81a3.812 3.812 0 0 1-3.81-3.814 3.812 3.812 0 0 1 3.81-3.814h152.38a3.812 3.812 0 0 1 3.81 3.814 3.812 3.812 0 0 1-3.81 3.814zM23.812 93.644a3.8 3.8 0 0 1-2.977-1.431 3.817 3.817 0 0 1 .595-5.361l76.19-61.017a3.808 3.808 0 0 1 5.355.596 3.817 3.817 0 0 1-.595 5.361L26.19 92.809a3.795 3.795 0 0 1-2.378.835zM94.921 144.492H54.286a3.812 3.812 0 0 1-3.81-3.814V100a3.812 3.812 0 0 1 3.81-3.814h40.635a3.812 3.812 0 0 1 3.81 3.814v40.678a3.813 3.813 0 0 1-3.81 3.814zm-36.826-7.628h33.016v-33.051H58.095v33.051z",
    fill: "#fff",
    "data-color": 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.603 144.492a3.812 3.812 0 0 1-3.81-3.814V100a3.812 3.812 0 0 1 3.81-3.814 3.812 3.812 0 0 1 3.81 3.814v40.678a3.812 3.812 0 0 1-3.81 3.814zM115.238 175a3.812 3.812 0 0 1-3.81-3.814V100a3.812 3.812 0 0 1 3.81-3.814 3.812 3.812 0 0 1 3.81 3.814v71.186a3.812 3.812 0 0 1-3.81 3.814zM145.714 175a3.812 3.812 0 0 1-3.81-3.814V100a3.812 3.812 0 0 1 3.81-3.814 3.812 3.812 0 0 1 3.81 3.814v71.186a3.812 3.812 0 0 1-3.81 3.814z",
    fill: "#fff",
    "data-color": 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.714 103.814h-30.476c-2.104 0-3.81-1.707-3.81-3.814s1.705-3.814 3.81-3.814h30.476c2.104 0 3.81 1.707 3.81 3.814s-1.706 3.814-3.81 3.814zM135.553 61.102a3.793 3.793 0 0 1-2.377-.835L97.62 31.792c-1.643-1.316-1.909-3.716-.595-5.361s3.712-1.911 5.355-.596l35.555 28.475a3.817 3.817 0 0 1 .595 5.361 3.8 3.8 0 0 1-2.977 1.431zM176.188 93.644a3.79 3.79 0 0 1-2.377-.835l-20.317-16.271a3.817 3.817 0 0 1-.595-5.361 3.808 3.808 0 0 1 5.355-.596l20.317 16.271a3.817 3.817 0 0 1 .595 5.361 3.804 3.804 0 0 1-2.978 1.431z",
    fill: "#fff",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealeState);
export default __webpack_public_path__ + "static/media/reale_state.855523179c2bd38a29abf3045303196d.svg";
export { ForwardRef as ReactComponent };